import { render, staticRenderFns } from "./StockCardSectionInventoryTasks.vue?vue&type=template&id=4354c077&scoped=true&"
import script from "./StockCardSectionInventoryTasks.vue?vue&type=script&lang=js&"
export * from "./StockCardSectionInventoryTasks.vue?vue&type=script&lang=js&"
import style0 from "./StockCardSectionInventoryTasks.vue?vue&type=style&index=0&id=4354c077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4354c077",
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QInnerLoading,QSpinnerGears}, component.options.components || {})
